import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://vurjzizsnrhtevotaddz.supabase.co';
const SUPABASE_KEY = 'sb_publishable_E6xs2Z2Am5MHdP5HAMXjhw_d9i5tDw6';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
